import type { PromptVersionDto } from "../api/prompts.api";

/**
 * Whether two versions hold the same prompt. Reverting between them would write a
 * row that differs only by timestamp, so the UI does not offer the action and the
 * API would no-op if it did.
 */
export function isSameVersionContent(
  a: PromptVersionDto | undefined,
  b: PromptVersionDto | undefined,
): boolean {
  if (!a || !b) return false;
  if (a.content !== b.content) return false;
  if (a.model !== b.model) return false;

  // Variables are a set on the version, so order carries no meaning.
  const aNames = [...a.variables].sort();
  const bNames = [...b.variables].sort();
  return (
    aNames.length === bNames.length && aNames.every((name, idx) => name === bNames[idx])
  );
}
